import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { MdClose } from 'react-icons/md';
import Backdrop from '../Backdrop/Backdrop';

const Modal = ({ title, children, open, size, onClose, onOpen, containerClassName }) => {
  useEffect(() => onOpen(), []);

  return open ? (
    <div className="fixed top-0 left-0 z-50 flex items-center justify-center w-full h-screen px-5">
      <Backdrop onClick={onClose} active={open} />
      <div
        className={`relative z-10 w-full max-w-screen-${size} px-8 py-5 bg-white rounded-md ${containerClassName}`}
      >
        {title && (
          <div className="flex items-center justify-between pb-3 mb-3 border-b">
            <div className="text-lg font-semibold text-gray-800">{title}</div>
            <button type="button" onClick={onClose}>
              <MdClose size={22} />
            </button>
          </div>
        )}
        <div>{children}</div>
      </div>
    </div>
  ) : (
    ''
  );
};

Modal.SIZES = {
  SMALL2X: 'xs',
  SMALL: 'sm',
  MEDIUM: 'md',
  LARGE: 'lg',
  LARGE2X: 'xl',
};

Modal.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  title: PropTypes.string,
  open: PropTypes.bool,
  size: PropTypes.oneOf(Object.values(Modal.SIZES)),
  onClose: PropTypes.func,
  onOpen: PropTypes.func,
  containerClassName: PropTypes.string,
};

Modal.defaultProps = {
  children: '',
  title: '',
  size: Modal.SIZES.SMALL,
  open: false,
  onClose: () => {},
  onOpen: () => {},
  containerClassName: '',
};

export default Modal;
